

























































import { computed, defineComponent } from '@nuxtjs/composition-api';
import { PropType } from 'vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

type CardStyleType = 'normal' | 'compact';

export default defineComponent({
  name: 'SfProductCardHorizontalSkeleton',
  components: {
    SkeletonLoader,
  },
  props: {
    cardStyle: {
      type: String as PropType<CardStyleType>,
      default: '',
    },
  },
  setup(props) {
    const isCompact = computed(() => props.cardStyle === 'compact');
    return {
      isCompact,
    };
  },
});
